var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "prop-editor inline-block",
      class: { "no-grid": _vm.noGrid },
      staticStyle: { padding: "2px" },
      style: _vm.get_style()
    },
    [
      _vm.title
        ? _c(
            "table",
            { staticClass: "simple-tbl", staticStyle: { width: "100%" } },
            [
              _c("thead", { staticClass: "head" }, [
                _c(
                  "tr",
                  { staticClass: "row", staticStyle: { height: "40px" } },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "font-size": "14px"
                        },
                        attrs: { title: _vm.name }
                      },
                      [_vm._v(_vm._s(_vm.title))]
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "simple-tbl", staticStyle: { width: "100%" } },
        [
          _c(
            "tbody",
            { staticClass: "body" },
            _vm._l(_vm.propItems, function(propItem, index) {
              return _c("tr", { key: propItem.code, staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticClass: "label",
                    staticStyle: {
                      "text-align": "right",
                      "padding-right": "6px",
                      "padding-top": "11px",
                      width: "100px !important"
                    },
                    style: _vm.getLabelStyle()
                  },
                  [
                    propItem.tooltip && !_vm.viewMode && !_vm.readOnly
                      ? _c("i", {
                          staticClass: "el-icon-info",
                          attrs: { title: propItem.tooltip }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("label", { staticStyle: { "font-size": "13px" } }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isRequired(propItem),
                              expression: "isRequired(propItem)"
                            }
                          ],
                          staticStyle: {
                            color: "red",
                            "font-weight": "bold",
                            "font-size": "14px"
                          }
                        },
                        [_vm._v("* ")]
                      ),
                      _vm._v(_vm._s(propItem.label))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("swb-pattern-input", {
                      ref: _vm.get_itemRefId(propItem),
                      refInFor: true,
                      attrs: {
                        viewMode: _vm.viewMode,
                        readOnly: _vm.readOnly,
                        inputWidth: _vm.get_itemWidth(propItem),
                        pattern: _vm.get_itemPattern(propItem),
                        inputType: propItem.inputType,
                        asDropdown: propItem.asDropdown,
                        valueType: propItem.valueType,
                        initValue: propItem.value,
                        minRows: propItem.minRows,
                        maxRows: propItem.maxRows,
                        maxLength: propItem.maxLength
                      }
                    })
                  ],
                  1
                )
              ])
            })
          )
        ]
      ),
      _vm._v(" "),
      _vm.showBtnBar
        ? _c(
            "table",
            { staticClass: "simple-tbl", staticStyle: { width: "100%" } },
            [
              _c("tfoot", { staticClass: "foot" }, [
                _c(
                  "tr",
                  { staticClass: "row", staticStyle: { height: "60px" } },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "vertical-align": "middle"
                        },
                        attrs: { colspan: "2" }
                      },
                      [
                        _vm.onCancel != null
                          ? _c("el-button", { on: { click: _vm.do_cancel } }, [
                              _vm._v("取 消")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.onConfirm != null
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "60px" },
                                on: { click: _vm.do_confirm }
                              },
                              [_vm._v("确 定")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59d8902f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d8902f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/ctrl/PropEditor.vue
// module id = 1660
// module chunks = 1